import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

const limit = 10
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
   

    return(
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] p-[16px]" style={{overflow:'auto'}}>
            
            {/* <div className="text-[#6E604C] text-[24px] font-bold w-full text-left">
                歡迎回來, {props.token.username}
            </div> */}
            <img src='/cms/home.png' style={{width:'100%',objectFit:'contain'}}/>
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)


